import { RostersSummary } from '../../interfaces/DataQcInterface';
import { getRostersSummary } from '../../services/dataQcSummaryService';
import WithDataWrapper from '../reusable/WithDataWrapper';
import DataQcCardContentWithTable from './DataQcCardContentWithTable';
import { STUDENT_ROSTER_ITEMS_PER_PAGE } from '../../constants';
import useSchools from '../hooks/useSchools';
import useExternalSchoolCheck from './hooks/useExternalSchoolCheck';
import ExternalSchoolMessage from './ExternalSchoolMessage';

const columns = [
  { key: 'name', className: '' },
  { key: 'student_count', className: 'align-right' },
];

interface RosterContentProps {
  data: RostersSummary;
}

export function RosterContent({ data }: RosterContentProps) {
  const { dataQcSchool } = useSchools();
  const shouldShowExternalMessage = useExternalSchoolCheck();

  const { total_student_count, schools } = data;

  if (shouldShowExternalMessage) {
    return <ExternalSchoolMessage message="We do not collect roster data for external schools." />;
  }

  return (
    <div className="roster-content">
      <div className="students-schools-count">
        <p data-testid="students-info">
          <span>{total_student_count}</span> students
        </p>
        {!dataQcSchool && (
          <p data-testid="schools-info">
            <span>{schools.length}</span> schools
          </p>
        )}
      </div>
      {!dataQcSchool && (
        <DataQcCardContentWithTable
          schools={schools}
          columns={columns}
          totalItems={schools.length}
          pageSize={STUDENT_ROSTER_ITEMS_PER_PAGE}
        />
      )}
    </div>
  );
}

const RosterContentWithData = () => {
  const { dataQcSchool } = useSchools();
  const shouldShowExternalMessage = useExternalSchoolCheck();

  if (shouldShowExternalMessage) {
    return <ExternalSchoolMessage message="We do not collect roster data for external schools." />;
  }

  const fetchData = (eoaId: string, access_token: string) => getRostersSummary(eoaId, access_token, dataQcSchool);

  return (
    <WithDataWrapper
      fetchData={fetchData}
      errorMessage="Error occured while fetching rosters summary data!"
      initialState={{ schools: [], total_student_count: 0 }}
      options={{
        dependencies: [dataQcSchool],
        areDependenciesRequired: false,
      }}
    >
      {(data) => <RosterContent data={data} />}
    </WithDataWrapper>
  );
};

export default RosterContentWithData;
